import React from 'react';
import {
  IBookingEvent,
  IEventAction,
  IRemindAppointmentDto,
  PersonAppointmentStatus,
} from 'modules/booking/interfaces';
import { Loader } from 'common/components';
import EventDetails from './EventDetails';
import { PeakModules } from 'common/constants/peakModules';
import { SenderAvailabilityTypeList } from 'modules/booking/constants/senderAvailability';
import { EShortNotificationType } from 'modules/booking/constants/notificationType';
import { IFormParticipateEvent } from 'common/components/PersonProfile/components/Appointments/ParticipationModal/ParticipationModal';

interface IProps {
  personId?: number;
  event?: IBookingEvent;
  appointmentStatus?: PersonAppointmentStatus;
  isEventDetailsLoading?: boolean;
  isEventActionLoading?: boolean;
  onEdit?: (event: IBookingEvent) => void;
  onCancel?: (formValues: IEventAction) => void;
  onClose?: () => void;
  onDelete?: (formValues: IEventAction) => void;
  onRemind?: (formValues: IRemindAppointmentDto) => void;
  onRestore?: (event: IBookingEvent) => void;
  onCancelParticipation?: (formData: IFormParticipateEvent) => void;
  onConfirmParticipation?: (formData: IFormParticipateEvent) => void;
  onJoinClass?: (formData: IFormParticipateEvent) => void;
  handleOverflow?: (value) => void;
  readOnly?: boolean;
  module?: PeakModules;
  onDuplicate?: (isDuplicateParticipants: boolean) => void;
  type: SenderAvailabilityTypeList;
  onLoadSenderAvailability?: (
    type: SenderAvailabilityTypeList,
    shortTypeEvent: EShortNotificationType,
  ) => void;
}

const EventDetailsContainer = ({
  personId,
  module,
  readOnly,
  handleOverflow,
  event,
  isEventDetailsLoading,
  isEventActionLoading,
  onEdit,
  onClose,
  onCancel,
  onDelete,
  onRestore,
  onDuplicate,
  onRemind,
  type,
  appointmentStatus,
  onCancelParticipation,
  onConfirmParticipation,
  onLoadSenderAvailability,
  onJoinClass,
}: IProps): JSX.Element => (
  <>
    {!!isEventDetailsLoading && <Loader />}
    <EventDetails
      personId={personId}
      module={module}
      event={event}
      onEdit={onEdit}
      onClose={onClose}
      onDelete={onDelete}
      onCancel={onCancel}
      appointmentStatus={appointmentStatus}
      onCancelParticipation={onCancelParticipation}
      onConfirmParticipation={onConfirmParticipation}
      onRestore={onRestore}
      onDuplicate={onDuplicate}
      onRemind={onRemind}
      handleOverflow={handleOverflow}
      readOnly={readOnly}
      isEventActionLoading={!!isEventActionLoading}
      type={type}
      onLoadSenderAvailability={onLoadSenderAvailability}
      onJoinClass={onJoinClass}
    />
  </>
);

export default EventDetailsContainer;
